import { colors } from "../../../global";

const AvgTimeToClose = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-start gap-8">
        {/* LEFT KPI */}
        <div className="flex-shrink-0">
          <div className="flex items-center gap-3 mb-4">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${colors.primary}15` }}
            >
              <svg
                className="w-5 h-5"
                style={{ color: colors.primary }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <p
              className="text-xs font-medium uppercase tracking-wide"
              style={{ color: colors.secondary }}
            >
              Avg Time to Close
            </p>
          </div>

          <p className="text-5xl font-bold" style={{ color: colors.primary }}>
            {data.averageDays}
            <span className="text-2xl ml-1">days</span>
          </p>
        </div>

        {/* RIGHT LIST */}
        <div
          className="flex-1 border-l pl-8"
          style={{ borderColor: colors.gray }}
        >
          <p
            className="text-xs font-medium uppercase tracking-wide mb-3"
            style={{ color: colors.secondary }}
          >
            Longest Open Tickets
          </p>
          <ul className="space-y-2">
            {data.longestTickets.map((item, idx) => (
              <li key={idx} className="flex items-start text-sm">
                <span
                  className="inline-block w-1.5 h-1.5 rounded-full mt-1.5 mr-3 flex-shrink-0"
                  style={{ backgroundColor: colors.accent }}
                />
                <div>
                  <span
                    className="font-medium"
                    style={{ color: colors.primary }}
                  >
                    {item.name}
                  </span>
                  <span style={{ color: colors.secondary }}>
                    {" – "}
                    <span className="font-semibold">{item.months}</span> months
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AvgTimeToClose;
